 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLCH00_FM01_PREF from '@/components/xhtml/ch00_fm01_pref'
 import XHTMLCH00_FM02_HTITLE from '@/components/xhtml/ch00_fm02_htitle'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLGROVEATLANTICLITHUB from '@/components/xhtml/groveatlanticlithub'
 import XHTMLCH00_FM03_TITLE from '@/components/xhtml/ch00_fm03_title'
 import XHTMLCH00_FM04_COPY from '@/components/xhtml/ch00_fm04_copy'
 import XHTMLCH00_FM05_DEDI from '@/components/xhtml/ch00_fm05_dedi'
 import XHTMLCH00_FM06_PART1 from '@/components/xhtml/ch00_fm06_part1'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH06_PART2 from '@/components/xhtml/ch06_part2'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH09_PART3 from '@/components/xhtml/ch09_part3'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLCH15_PART4 from '@/components/xhtml/ch15_part4'
 import XHTMLCH16 from '@/components/xhtml/ch16'
 import XHTMLCH17 from '@/components/xhtml/ch17'
 import XHTMLCH18 from '@/components/xhtml/ch18'
 import XHTMLCH19 from '@/components/xhtml/ch19'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLCH20_ACK from '@/components/xhtml/ch20_ack'
 import XHTMLCH21_ABG from '@/components/xhtml/ch21_abg'
 import XHTMLCH22_DISPO from '@/components/xhtml/ch22_dispo'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/ch00_fm01_pref",
 			"name" : "xhtml/ch00_fm01_pref",
 			"component" : XHTMLCH00_FM01_PREF
 		},
 		{
 			"path" : "/xhtml/ch00_fm02_htitle",
 			"name" : "xhtml/ch00_fm02_htitle",
 			"component" : XHTMLCH00_FM02_HTITLE
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/groveatlanticlithub",
 			"name" : "xhtml/groveatlanticlithub",
 			"component" : XHTMLGROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/xhtml/ch00_fm03_title",
 			"name" : "xhtml/ch00_fm03_title",
 			"component" : XHTMLCH00_FM03_TITLE
 		},
 		{
 			"path" : "/xhtml/ch00_fm04_copy",
 			"name" : "xhtml/ch00_fm04_copy",
 			"component" : XHTMLCH00_FM04_COPY
 		},
 		{
 			"path" : "/xhtml/ch00_fm05_dedi",
 			"name" : "xhtml/ch00_fm05_dedi",
 			"component" : XHTMLCH00_FM05_DEDI
 		},
 		{
 			"path" : "/xhtml/ch00_fm06_part1",
 			"name" : "xhtml/ch00_fm06_part1",
 			"component" : XHTMLCH00_FM06_PART1
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
 		{
 			"path" : "/xhtml/ch03",
 			"name" : "xhtml/ch03",
 			"component" : XHTMLCH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js